import React from 'react'
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'
import { Stack } from 'src/viewLayer/components/DesignSystem'
import {
  SocialLogin,
  TermsAndConditions,
} from 'src/viewLayer/components/shared/SharedViewComponent'
import { hasNativeBackButton } from 'src/viewLayer/navigation'

import Footer from './Footer'
import Header from './Header'
import { BackgroundItemsContainer, Card, CardContainer, CardLayout } from './index.styled'

const WebCardLayout = ({
  appType,
  BackgroundItems,
  children,
  hideTermsAndConditions = false,
  Image,
  isPasswordPage,
  magicLink,
  subtitle,
  title,
}) => (
  <CardLayout align="center">
    <CardContainer align="center" className="CardLayoutComponent">
      <Card
        alignItems="center"
        padding={{
          small: [60, 8, 24, 8],
          xxsmall: [36, 8, 10, 8],
        }}
      >
        <Header Image={Image} subtitle={subtitle} title={title} />
        {children}
        {isPasswordPage ? magicLink : <SocialLogin appType={appType} />}
        {!hideTermsAndConditions && <TermsAndConditions />}
      </Card>
      <BackgroundItemsContainer>
        {BackgroundItems &&
          BackgroundItems.map((BackgroundItem, index) => <BackgroundItem key={index} />)}
      </BackgroundItemsContainer>
    </CardContainer>
    <Footer />
  </CardLayout>
)

const NativeMobileCardLayout = ({
  children,
  Image,
  isPasswordPage,
  magicLink,
  subtitle,
  title,
}) => {
  const paddingTop = hasNativeBackButton() ? 26 : 80

  return (
    <CardLayout align="center">
      <CardContainer webview>
        <Stack
          alignItems="center"
          padding={{
            small: [paddingTop, 5, 24, 5],
            xxsmall: [paddingTop, 0, 10, 0],
          }}
        >
          <Header Image={Image} subtitle={subtitle} title={title} />
          {children}
        </Stack>
        {isPasswordPage && magicLink}
      </CardContainer>
    </CardLayout>
  )
}

export default (properties) => {
  const { devicePath } = useAppConfigContext()
  return devicePath === 'login' ? (
    <WebCardLayout {...properties} />
  ) : (
    <NativeMobileCardLayout {...properties} />
  )
}
